import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export const supportTicketTypeOptions = [
  { label: 'Externo', value: 'external' },
  { label: 'Interno', value: 'internal' },
]

export const supportTicketTypeStrategy = optionsToStrategy(supportTicketTypeOptions)
